/** Counts what a reader sees as characters — Bluesky's unit for its 300 limit.
 *  "한" is one, a flag is one, a family emoji is one; `.length` would say 1,
 *  4 and 11. Falls back to code points where Intl.Segmenter is missing, which
 *  over-counts emoji and so errs on the safe side. */
export function countGraphemes(text: string): number {
  const Segmenter = (Intl as { Segmenter?: typeof Intl.Segmenter }).Segmenter
  if (Segmenter) {
    let n = 0
    for (const _ of new Segmenter(undefined, { granularity: 'grapheme' }).segment(text)) n++
    return n
  }
  return Array.from(text).length
}
